import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {},
    piNo: {
      margin: "25px 0",
      display: "flex",
      alignItems: "center",
      "& img": {
        marginRight: 10
      }
    },
    itemPiNo: {
      marginRight: 10
    },
    mainContent: {
      background: "#FFF",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      borderRadius: 12,
      padding: "2.4rem"
    },
    titleField: {
      marginBottom: 5
    },
    soldToInfo: {
      background: "#F2FAFB",
      borderRadius: 4,
      padding: "1.2rem"
    },
    textCode: {
      color: theme.palette.info.dark,
      marginBottom: 5,
      fontSize: "1.8rem"
    },
    textAddress: {
      color: theme.palette.grey[800],
      marginBottom: 5,
      whiteSpace: "pre-line"
    },
    selectField: {
      "& .MuiFormControl-root": {
        height: 37
      }
    },
    pickAddress: {
      display: "flex"
    },
    addressContent: {
      maxWidth: "90%"
    },
    btnEdit: {
      marginLeft: "auto",
      height: 32
    },
    titleArea: {
      display: "flex",
      alignItems: "center",
      "& img": {
        marginRight: 10
      }
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    lineMultiText: {
      whiteSpace: "pre-line"
    }
  }),
  { name: "OrderHeaderTab" }
);

export default useStyles;
